import { useEffect, useMemo, useState } from 'react';
import { useTheme } from '../useTheme';
export const useMediaQuery = function () {
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }
  const {
    mediaQueries
  } = useTheme();
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const [media, setMedia] = useState(false);
  const query = useMemo(() => {
    const types = Object.keys(mediaQueries);
    if (!queries.every(queryInput => types.includes(queryInput))) {
      throw new RangeError("The query provided ".concat(queries.toString(), " does not exist in the theme"));
    }
    return queries.map(queryInput => mediaQueries[queryInput]).join();
  }, []);
  useEffect(() => {
    let active = true;
    if (!supportMatchMedia) return undefined;
    const queryList = window.matchMedia(query);
    function updateMatch() {
      if (active) setMedia(queryList.matches);
    }
    updateMatch();
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, supportMatchMedia]);
  return media;
};